
import { createPortal } from "react-dom";
import { useEffect, useState } from "react";

export default function LogoutModal({ open, onConfirm, onCancel }) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  if (!mounted || !open) return null;

  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-start justify-center bg-black/70">
      <div className="bg-slate-900 text-white p-6 rounded-lg shadow-xl max-w-sm w-full border border-white/10">
        <h2 className="text-lg font-semibold mb-2">Confirm Logout</h2>
        <p className="text-sm text-white/70 mb-6">Are you sure you want to logout?</p>
        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-sm bg-white/10 hover:bg-white/20 rounded"
          >
            Cancel
          </button>
          <button
            onClick={() => { sessionStorage.clear(); onConfirm(); }}
            className="px-4 py-2 text-sm bg-purple-700 hover:bg-purple-900 rounded"
          >
            Logout
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
